import { z } from 'zod';
import { TypedApiClient } from '../index';

// Zod schemas for Product History API
export const ProductHistoryResponseSchema = z.object({
  id: z.string(),
  product_id: z.string(),
  change_type: z.string(),
  old_values: z.record(z.any()).optional().nullable(),
  new_values: z.record(z.any()).optional().nullable(),
  user_id: z.string().optional().nullable(),
  organization_id: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
}).strict();

export const CreateProductHistorySchema = z.object({
  productId: z.string(),
  changeType: z.string(),
  oldValues: z.record(z.any()).optional(),
  newValues: z.record(z.any()).optional(),
  userId: z.string().optional(),
});

// Type exports
export type ProductHistoryResponse = z.infer<typeof ProductHistoryResponseSchema>;
export type CreateProductHistory = z.infer<typeof CreateProductHistorySchema>;

// API factory function
export function createProductHistoryApi(client: TypedApiClient) {
  return {
    getProductHistory: (params: {
      productId: string;
      changeType?: string;
      limit?: number;
      offset?: number;
    }): Promise<ProductHistoryResponse[]> => {
      return client.get('/product-history', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(ProductHistoryResponseSchema),
      });
    },

    createProductHistory: (data: CreateProductHistory): Promise<ProductHistoryResponse> => {
      CreateProductHistorySchema.parse(data);
      return client.post('/product-history', {
        data,
        responseSchema: ProductHistoryResponseSchema,
      });
    },
  };
}
